import {Component, ElementRef, inject, ViewChild} from '@angular/core';
import { RouterLink} from "@angular/router";
import {NavHeaderComponent} from "../nav-header/nav-header.component";
import {PortfolioCardComponent} from "../portfolio-card/portfolio-card.component";
import {StatisticsComponent} from "../statistics/statistics.component";
import {MatButton} from "@angular/material/button";
import {FooterComponent} from "../footer/footer.component";
import {WorkStore} from "./store/work-store";
import {DotsLoaderComponent} from "../../../../core/helper-components/dots-loader/dots-loader.component";

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  imports: [
    NavHeaderComponent,
    PortfolioCardComponent,
    StatisticsComponent,
    RouterLink,
    MatButton,
    FooterComponent,
    DotsLoaderComponent
  ],
  styleUrls: ['./portfolio.component.scss'],
  providers: [WorkStore],
})
export class PortfolioComponent {

  readonly #store: any = inject(WorkStore);

  protected readonly works = this.#store.works;
  protected readonly isLoading = this.#store.isLoading;

  protected reload(): void {
    this.#store.reload();
  }

  @ViewChild('section') section!: ElementRef;

  scrollToSection() {
    this.section.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

}
